module.exports = __webpack_public_path__ + "img/visa.cc09737b.svg";